import { createSlice } from '@reduxjs/toolkit';
import { reportsTexts } from 'locale/es';
import { toast } from './notificationReducer';
import ReportService from 'services/ReportService';

const initialState = { data: [], loading: false, error: null };

const reportsByPatientSlice = createSlice({
  name: 'reportsByPatient',
  initialState,
  reducers: {
    setReports(state, action) {
      const { data } = action.payload;
      return { ...state, data, loading: false, error: null };
    },
    setReportsLoading(state) {
      state.loading = true;
      state.error = null;
    },
    setReportsError(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetReportsByPatient(state, action) {
      return initialState;
    },
  },
});

export const {
  setReports,
  setReportsLoading,
  setReportsError,
  resetReportsByPatient,
} = reportsByPatientSlice.actions;

export const initializeReportsByPatient = (patientId) => {
  return async (dispatch) => {
    try {
      dispatch(setReportsLoading());

      const { data } = await ReportService.getAllByPatient(patientId);
      dispatch(setReports({ data }));
    } catch (error) {
      console.error(error);
      dispatch(
        setReports({ message: error.message, status: error.response?.status })
      );
      dispatch(toast(reportsTexts.LOADING_ERROR, 'error'));
    }
  };
};

export default reportsByPatientSlice.reducer;
